<template>
    <div class="edit-notes">
        <div class="mb-4">
            <btn theme="success" class="header-button mr-2" size="sm" label="Notiz erstellen" modal="edit-note" :payload="{id_user: this.id_user, id_partner: this.id_partner}" />
            <btn v-if="!showArchived" class="header-button" size="sm" theme="secondary" label="Archivierte Notizen anzeigen" @click="toggleShowArchived"/>
            <btn v-else theme="primary" class="header-button" size="sm" label="Aktive Notizen anzeigen" @click="toggleShowArchived"/>
        </div>
        <div v-if="notes.length > 0">
            <div class="note-element" v-for="note of notes" :key="note.id_note">
                <div v-if="!note.expanded" class="note-collapsed p-1">
                    <flex>
                        <icon name="play" class="arrow mdi-rotate-90 mdi-12px mr-2" @click="toggleExpandNote(note)"/>
                        <div class="test flex-grow-1">
                            <flex>
                                <div class="category-label flex-grow-1 font-weight-bold">{{ __(`note_type/${note.type}`) }}</div>
                                <div class="creator-date-information">-{{ getCreatorFullname(note.creator) || "inaktiver Nutzer" }}, {{ parseDate(note.created_at) }}</div>
                            </flex>
                            <div v-if="note.type === 2" class="file-url">
                                <a :href="getNoteFileUrl(note)" target="_blank">{{ note.file.name }}</a>
                            </div>
                            <div v-else class="content">
                                {{ note.text }}
                            </div>
                        </div>
                    </flex>
                </div>
                <div v-else class="note-expanded p-1">
                    <div class="d-flex justify-content-start flex-nowrap flex-row">
                        <icon name="play" class="arrow mdi-rotate-270 mdi-12px mr-2 mt-1 align-top" @click="toggleExpandNote(note)"/>
                        <div class="flex-grow-1">
                            <edit-note-form :note="note"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="showArchived">
            Für diesen
            <template v-if="id_partner != null">Partner</template>
            <template v-else>Nutzer</template>
            existieren keine archivierten Notizen.
        </div>
        <div v-else>
            Für diesen
            <template v-if="id_partner != null">Partner</template>
            <template v-else>Nutzer</template>
            existieren keine aktiven Notizen.
        </div>
    </div>
</template>

<style lang="scss">
    .edit-notes {

        .header-button {
            margin-bottom: 5px;

            @include media-breakpoint-down('xs') {
                width: 100%;
            }
        }

        .arrow {
            margin: auto;

            &:hover {
                color: $red;
                cursor: pointer;
            }
        }

        .note-collapsed {

            .content {
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                min-width: 0;
            }

            .test {
                min-width: 0;
            }
        }

        .note-element {
            border-bottom: 1px solid $gray-300;

            .creator-date-information {
                color: $gray-600;
                font-style: italic;
                font-size: 14px;
            }
        }
    }
</style>

<script>
    import Note from "$src/models/noteModel";
    import moment from "moment";

    export default {
        name: "EditNotes",

        props: {
            id_user: {type: [Number, String], default: null},
            id_partner: {type: [Number, String], default: null},
        },

        computed: {
            notes() {
                if (this.id_partner) {
                    return Note.query().where('id_partner', parseInt(this.id_partner)).where('archived', this.showArchived).orderBy('created_at', 'desc').get();
                } else {
                    return Note.query().where('id_user', parseInt(this.id_user)).where('archived', this.showArchived).orderBy('created_at', 'desc').get();
                }
            },
        },

        data() {
            return {
                showArchived: false,
            };
        },

        methods: {
            getNoteSectionAction() {
                if (this.$can('user.edit_notes')) {
                    return [];
                } else {
                    return [];
                }
            },

            getNoteFileUrl(note) {
                return `/api/file/content/${btoa(note.file.id_file)}`;
            },

            parseDate(date) {
                return moment(date).format('DD.MM.YYYY');
            },

            toggleExpandNote(note) {
                if (!note.hasOwnProperty('expanded')) {
                    this.$set(note, 'expanded', true);
                } else {
                    note.expanded = !note.expanded;
                }
            },

            getActions() {
                return [
                    {
                        label: 'Notiz hinzufügen',
                        modal: 'edit-note',
                        payload: {
                            id_user: this.id_user,
                            id_partner: this.id_partner,
                        },
                    },
                ];
            },

            handleUpload(file) {
                this.$form.note.file = file;
                this.fileError = false;
            },

            handleUploadError(type) {
                let message;
                switch (type) {
                    case 'max-size': message = 'Die ausgewählte Datei hat nicht das richtige Format.'; break;
                    case 'format': message = 'Die ausgewählte Datei ist zu groß. Die Maximale Dateigröße beträgt 5 MB.'; break;
                    default: message = 'Beim Hochladen der Datei ist ein Fehler aufgetreten. Probiere es bitte später erneut.'; break;
                }
                this.$notify.danger({body: message, timeout: 5});
            },

            toggleShowArchived() {
                this.notes.forEach(note => {
                    if (note.hasOwnProperty('expanded')) {
                        note.expanded = false;
                    }
                });
                this.showArchived = !this.showArchived;
            },

            getCreatorFullname(creator) {
                if (!creator) {
                    return null;
                }
                return `${creator.first_name} ${creator.last_name}`;
            },
        },

        async created() {
            if (this.id_partner) {
                this.$loading('global', true);
                await this.$store.dispatch('backend/fetchPartnerNotes', {id_partner: this.id_partner});
                this.$loading('global', false);
            }
        },
    };
</script>